import React from 'react'
import './style.css'
/**
* @author
* @function Logo
**/

const Logo = (props) => {
  return(
    <div className="logo">
        <a href="#">Peter Rai</a>
    </div>
   )

 }

export default Logo